/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiRunMetric } from './ApiRunMetric';
import {
  ApiRunMetricFromJSON,
  ApiRunMetricFromJSONTyped,
  ApiRunMetricToJSON,
  ApiRunMetricToJSONTyped,
} from './ApiRunMetric';

/**
 *
 * @export
 * @interface RunServiceReportRunMetricsV1Body
 */
export interface RunServiceReportRunMetricsV1Body {
  /**
   * List of metrics to report.
   * @type {Array<ApiRunMetric>}
   * @memberof RunServiceReportRunMetricsV1Body
   */
  metrics?: Array<ApiRunMetric>;
}

/**
 * Check if a given object implements the RunServiceReportRunMetricsV1Body interface.
 */
export function instanceOfRunServiceReportRunMetricsV1Body(
  value: object,
): value is RunServiceReportRunMetricsV1Body {
  return true;
}

export function RunServiceReportRunMetricsV1BodyFromJSON(
  json: any,
): RunServiceReportRunMetricsV1Body {
  return RunServiceReportRunMetricsV1BodyFromJSONTyped(json, false);
}

export function RunServiceReportRunMetricsV1BodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RunServiceReportRunMetricsV1Body {
  if (json == null) {
    return json;
  }
  return {
    metrics:
      json['metrics'] == null
        ? undefined
        : (json['metrics'] as Array<any>).map(ApiRunMetricFromJSON),
  };
}

export function RunServiceReportRunMetricsV1BodyToJSON(
  json: any,
): RunServiceReportRunMetricsV1Body {
  return RunServiceReportRunMetricsV1BodyToJSONTyped(json, false);
}

export function RunServiceReportRunMetricsV1BodyToJSONTyped(
  value?: RunServiceReportRunMetricsV1Body | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metrics:
      value['metrics'] == null
        ? undefined
        : (value['metrics'] as Array<any>).map(ApiRunMetricToJSON),
  };
}
